export default __webpack_public_path__ + "static/media/avataricon.d358411b.svg";